module.exports = __webpack_public_path__ + "static/media/py.6fb323ff.svg";